import type { NativeHubPacket, NativeVideoTransport } from '@playcastdotio/PeerCore';

/** Separate IPC channel avoids logging SDP or short-lived TURN credentials. */
export class NativeVideoIpcTransport implements NativeVideoTransport {
  private listeners = new Set<(packet: NativeHubPacket) => void>();
  private rejectListeners = new Set<(payload: { sessionId?: string; reason: string }) => void>();
  constructor() {
    window.playcast?.ipc.on('nativeVideoReply', (packet) => {
      for (const listener of this.listeners) listener(packet as unknown as NativeHubPacket);
    });
    window.playcast?.ipc.on('nativeVideoReject', (payload) => {
      for (const listener of this.rejectListeners) listener(payload as unknown as { sessionId?: string; reason: string });
    });
  }
  send(packet: NativeHubPacket): void {
    window.playcast?.ipc.send('nativeVideoRequest', packet as never);
  }
  subscribe(callback: (packet: NativeHubPacket) => void): () => void {
    this.listeners.add(callback);
    return () => {
      this.listeners.delete(callback);
    };
  }
  subscribeRejects(callback: (payload: { sessionId?: string; reason: string }) => void): () => void {
    this.rejectListeners.add(callback);
    return () => {
      this.rejectListeners.delete(callback);
    };
  }
}
